import {Flex, Image, Text, useDisclosure} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {DeliveryCostInfoModal} from 'components/shared';
import {FC} from 'react';
import {TranslationKeys} from 'translations';
import {IRestaurantDistancePriceResponse} from 'types';

import {OrderTotalListItem} from '..';

interface IProps {
  t: (term: TranslationKeys) => string;
  dynamicDeliveryPrice: IRestaurantDistancePriceResponse;
  deliveryAmount: number;
}

export const CostSurcharge: FC<IProps> = ({t, deliveryAmount, dynamicDeliveryPrice}) => {
  const {surcharge_for_out_area} = dynamicDeliveryPrice;
  const {isOpen: isOpenInfo, onOpen: onOpenInfo, onClose: onCloseInfo} = useDisclosure();
  return (
    <>
      <OrderTotalListItem
        title={t('FAR_AREA_SURCHARGE')}
        boxProps={{
          onClick: () => onOpenInfo(),
          borderBottom: '1px solid #E6E6E6',
          // flexDirection: `${!!deliveryAmount ? 'row' : 'column'}`,
          cursor: 'pointer',
          _hover: {color: colors.textGray},
        }}
      >
        <Flex justifyContent="space-between" alignItems="center">
          <Image w="30px" mr={['10px', '20px']} src="/profile-menu/info-icon.svg" alt="icon" />

          <Text as="span" fontWeight="500" color={!deliveryAmount ? colors.green : ''}>
            {`${surcharge_for_out_area} ${t('CURRENCY')}`}
          </Text>
        </Flex>
      </OrderTotalListItem>
      {isOpenInfo && <DeliveryCostInfoModal isOpen={isOpenInfo} onClose={onCloseInfo} t={t} />}
    </>
  );
};
